import { UserDashboardQuery } from '@website/types/graphqlOperations';
import { DateTime } from 'luxon';
import { useMemo } from 'react';
import BookingOwnerTripFormAlertItem from './BookingOwnerTripFormAlertItem';

type Props = {
  bookings: Pick<
    UserDashboardQuery['user']['bookings']['items'][number],
    'group' | 'spaces' | 'id' | 'trip' | 'user'
  >[];
};

export default function BookingOwnerTripFormAlert({ bookings }: Props) {
  const bookingsWithIncompleteGuestForm = useMemo(
    () =>
      bookings.filter((booking) => {
        const isTripDeparted =
          DateTime.fromISO(booking.group.start.utc, { zone: 'utc' })
            .diffNow()
            .as('days') < 1;
        const spacesWithIncompleteGuestForm = booking.spaces.filter((space) => {
          if (
            // We want to show the alert if the space is for the booking owner
            // or the space is for a guest who isn't invited yet
            (!space.guest?.userID || space.guest.userID === booking.user.id) &&
            !space.guest?.completed &&
            space.active
          ) {
            return space;
          }
          return false;
        });
        if (spacesWithIncompleteGuestForm.length > 0 && !isTripDeparted) {
          return booking;
        }
        return false;
      }),
    [bookings],
  );

  return (
    <>
      {bookingsWithIncompleteGuestForm?.map((booking) => (
        <BookingOwnerTripFormAlertItem
          key={booking.id}
          bookingWithIncompleteGuestForm={booking}
        />
      ))}
    </>
  );
}
